export const delay = (ms) => {
  return new Promise((resolve) => setTimeout(() => resolve(true), ms));
};

export const isNumeric = (val) => {
  return /^-?\d+$/.test(val);
};
